<template>
  <v-card class="mx-auto left-panel" width="100%" tile>
    <v-list dense>
      <v-subheader class="panel-title">Admin Actions</v-subheader>
      <v-list-item-group v-model="page" color="primary" active-class="selected">
        <v-list-item
          v-ripple="{ class: `primary--text` }"
          v-for="(item, i) in pages"
          :key="i"
          @click="$emit('goTo', item.routeName)"
        >
          <v-list-item-content>
            <v-list-item-title
              class="text-left page-name"
              v-text="item.name"
            ></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-card>
</template>

<script>
export default {
  created() {
    console.log(this.$store.state.user.roles);
    if (this.$store.state.user.roles.my_app_admin) {
      this.pages = [
        {
          name: "Dashboard",
          routeName: "Dashboard",
        },
        {
          name: "Manage Announcements",
          routeName: "Announcements",
        },
        {
          name: "Manage Messages",
          routeName: "Messages",
        },
        {
          name: "Manage LOF and Expiry Notification",
          routeName: "LOFandExpiry",
        },
        {
          name: "Manage News and Events",
          routeName: "HomepageNewsEvents",
        },
        {
          name: "Manage Promotions",
          routeName: "HomepagePromotions",
        },
        {
          name: "Manage Videos",
          routeName: "Videos",
        },
        {
          name: "Manage Popups",
          routeName: "Popup",
        },
        {
          name: "Manage Notification Subscription",
          routeName: "SubscribeNotification",
        },
        {
          name: "Manage Homepage Services",
          routeName: "HomepageServices",
        },
        {
          name: "Manage Homepage Sections",
          routeName: "HomepageSections",
        },
        {
          name: "Manage App Versions",
          routeName: "ManageAppVersion",
        },
        {
          name: "================================",
        },
        {
          name: "Manage Interest Package IDs",
          routeName: "PackageIDs",
        },
      ];
    } else {
      this.pages = [
        {
          name: "Manage Promotion Redemptions",
          routeName: "HomepagePromotions",
        },
      ];
    }
  },
  data() {
    return {
      page: "1",

      //change route names according to what is defined in router/index.js
      pages: [],
    };
  },
  methods: {},
};
</script>

<style scoped>
.left-panel {
  border: 1px solid #eeeeee;
  box-shadow: 0px 1px 20px rgba(163, 163, 163, 0.25);
}

.left-panel .panel-title {
  font-size: 16px;
  padding: 15px;
  color: #212121;
  height: auto;
}

.left-panel div.v-list-item__content {
  padding: 15px 0;
}

.left-panel > .v-list {
  padding: 0;
}

.selected {
  background-color: #204281;
  -webkit-transition: background-color 0.3s;
  -moz-transition: background-color 0.3s;
  -o-transition: background-color 0.3s;
  transition: background-color 0.3s;
}

.selected .page-name {
  color: white;
}

.page-name {
  font-size: 14px;
  color: #212121;
  font-weight: 300;
}
</style>
